import { MoldOrderMainType } from '../../types/mold';
import { Check, ChevronDown } from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { MoldOrderTypeGroup } from '../../models/appState';

interface MoldOrderTypeFilterProps {
    onTypeCheck: (type: MoldOrderMainType | 'ALL') => void;
    selectedOrderType: MoldOrderMainType | 'ALL';
    options: MoldOrderTypeGroup[];
}
const MoldOrderTypeFilter: React.FC<MoldOrderTypeFilterProps> = ({
    onTypeCheck,
    selectedOrderType,
    options,
}) => {
    const config = {
        color: 'bg-blue-100',
        name: 'ประเภทใบงานทั้งหมด',
        textColor: 'text-blue-800',
        hovercolor: 'hover:bg-blue-300'
    };

    // Get the label for the selected order type from options
    const getSelectedLabel = () => {
        if (selectedOrderType === 'ALL') {
            return config.name;
        }
        const selected = options.find(option => option.value === selectedOrderType);
        return selected?.label || config.name;
    };
    
    const hasOptions = options.length > 0;
    
    if (!hasOptions) return <></>
    
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    className={`
                        flex items-center gap-2 px-3 py-2 rounded-full
                        ${config?.color}
                        ${config?.hovercolor}
                        border border-transparent
                        hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2
                        transition-all duration-200
                    `}
                >
                    {selectedOrderType !== 'ALL' && (
                        <Check className={`w-4 h-4 ${config?.textColor}`} />
                    )}
                    <span className={`text-base font-medium ${config?.textColor}`}>
                        {getSelectedLabel()}
                    </span>
                    <ChevronDown className={`w-4 h-4 ${config?.textColor}`} />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56 bg-white/95 backdrop-blur-sm" align="start">
                <DropdownMenuItem 
                    onClick={() => onTypeCheck('ALL')}
                    className={`
                        px-4 py-2 cursor-pointer
                        ${config?.hovercolor}
                        ${selectedOrderType === 'ALL' ? 'bg-blue-200' : ''}
                        flex items-center gap-2
                    `}
                >
                    {selectedOrderType === 'ALL' && <Check className={`w-4 h-4 ${config?.textColor}`} />}
                    <span className={`text-base ${config?.textColor}`}>
                        ทั้งหมด
                    </span>
                </DropdownMenuItem>
                {options.map(({ value, label }) => (
                    <DropdownMenuItem 
                        key={value}
                        onClick={() => onTypeCheck(value as MoldOrderMainType)}
                        className={`
                            px-4 py-2 cursor-pointer
                            ${config?.hovercolor}
                            ${selectedOrderType === value ? 'bg-blue-200' : ''}
                            flex items-center gap-2
                        `}
                    >
                        {selectedOrderType === value && <Check className={`w-4 h-4 ${config?.textColor}`} />}
                        <span className={`text-base ${config?.textColor}`}>
                            {label}
                        </span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export default MoldOrderTypeFilter;